/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectImageReference } from '../../models/project-image-reference';

export interface CreateProjectImageReference$Params {
  projectId: string;
      body?: ProjectImageReference
}

export function createProjectImageReference(http: HttpClient, rootUrl: string, params: CreateProjectImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectImageReference>> {
  const rb = new RequestBuilder(rootUrl, createProjectImageReference.PATH, 'post');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectImageReference>;
    })
  );
}

createProjectImageReference.PATH = '/project/{projectId}/images';
